"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Teller_1 = require("../../../../../../DriveScout/Billing/Teller");
var time_1 = require("../../../../../common/helpers/time");
var AdminStudentViewOrdersController = /** @class */ (function () {
    function AdminStudentViewOrdersController($stateParams, UsersModel) {
        var _this = this;
        this.$stateParams = $stateParams;
        this.loading = true;
        this.UsersModel = UsersModel;
        this.currentPage = 1;
        this.pageBy = 8;
        UsersModel.getStudentByID($stateParams.userId).then(function (response) {
            _this.student = response;
        });
        UsersModel.getStudentOrders({
            student_id: $stateParams.userId,
            per_page: this.pageBy,
        }).then(function (response) {
            _this.orders = response.orders.data.map(function (order) {
                order.created_at = (0, time_1.formatDateTime)(order.created_at, "MM/DD/YYYY h:mm A");
                order.lineitems = order.lineitems.map(function (item) {
                    return item;
                });
                return order;
            });
            _this.totalItems = response.orders.total;
            _this.loading = false;
        });
        this.centsToDollars = Teller_1.inDollars.bind(this);
    }
    AdminStudentViewOrdersController.prototype.pageChanged = function () {
        var _this = this;
        this.UsersModel.getStudentOrders({
            student_id: this.$stateParams.userId,
            page: this.currentPage,
            per_page: this.pageBy,
        }).then(function (response) {
            _this.orders = response.orders.data.map(function (order) {
                order.created_at = (0, time_1.formatDateTime)(order.created_at, "MM/DD/YYYY h:mm A");
                return order;
            });
        });
    };
    return AdminStudentViewOrdersController;
}());
AdminStudentViewOrdersController.$inject = ["$stateParams", "UsersModel"];
exports.default = AdminStudentViewOrdersController;
